import { render, staticRenderFns } from "./workspace-question-set-detail.vue?vue&type=template&id=05cf8a9c&scoped=true"
import script from "./workspace-question-set-detail.vue?vue&type=script&lang=js"
export * from "./workspace-question-set-detail.vue?vue&type=script&lang=js"
import style0 from "./workspace-question-set-detail.vue?vue&type=style&index=0&id=05cf8a9c&prod&lang=scss&scoped=true"
import style1 from "./workspace-question-set-detail.vue?vue&type=style&index=1&id=05cf8a9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cf8a9c",
  null
  
)

export default component.exports